import { render, staticRenderFns } from "./FormFullEditLink.vue?vue&type=template&id=208bac96"
import script from "./FormFullEditLink.vue?vue&type=script&lang=js"
export * from "./FormFullEditLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports